<select class="form-control form-control-sm" [(ngModel)]="model" (ngModelChange)="change()" [disabled]="disabled">
  <option *ngFor="let hour of hours" [value]="hour">{{ hour }}
  </option>
</select>